import React from 'react';

import classNames from 'classnames';

export default function Checkbox({
  label,
  name,
  value,
  onChange,
  onBlur,
  disabled,
  errors,
  touched,
  row,
  checkMarkAbsolute,
}) {
  const input = (
    <div className="h-[41px] flex items-center">
      <input
        id={name}
        name={name}
        type="checkbox"
        className={classNames(
          'w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600',
          {
            'absolute -right-6': checkMarkAbsolute,
          }
        )}
        onBlur={onBlur}
        onChange={onChange}
        value={true}
        checked={value}
        disabled={disabled}
      />
    </div>
  );

  return (
    <div
      className={classNames('flex', {
        'flex-col': !row,
        'flex-row items-center justify-between gap-2': row,
      })}
    >
      {label && (
        <label
          htmlFor={name}
          className={classNames(
            'block text-sm font-medium text-gray-900 dark:text-white',
            {
              'mb-2': !row,
              'flex items-center relative': checkMarkAbsolute,
            }
          )}
        >
          {label}
          {checkMarkAbsolute && input}
        </label>
      )}
      {!checkMarkAbsolute && input}
      {errors && touched && (
        <div className="text-red-500 text-sm mt-1">{errors}</div>
      )}
    </div>
  );
}
